export const AUTH_REQUIRED_EVENT = 'voxnela:auth-required'

export const GENERATION_AUTH_REQUIRED_MESSAGE =
  'Görsel üretmek ve üretim kredilerini kullanmak için giriş yapmalısın.'

export function requestGenerationSignIn(): void {
  window.dispatchEvent(new CustomEvent(AUTH_REQUIRED_EVENT, {
    detail: { message: GENERATION_AUTH_REQUIRED_MESSAGE },
  }))
}
